import { useMobileNavigation } from "@/context/MobileNavigationContext";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function MobileCTA() {
  const { open: mobileMenuOpen } = useMobileNavigation();
  const { user, ready } = useAuth();
  const { pathname } = useLocation();
  const [expertName, setExpertName] = useState("");
  const expertMatch = pathname.match(/^\/eksperter\/([^/]+)$/);
  const expertId = expertMatch?.[1] || "";

  useEffect(() => {
    setExpertName("");
    if (!expertId) return;
    api.get(`/experts/${expertId}`)
      .then((response) => setExpertName((response.data?.name || "").split(" ")[0]))
      .catch(() => {});
  }, [expertId]);

  if (mobileMenuOpen) return null;

  if (!ready || user?.role === "expert" || user?.role === "admin") return null;
  if (pathname.startsWith("/beskriv-problem") || pathname.startsWith("/konsultation") || pathname.startsWith("/book") || pathname.startsWith("/log-ind") || pathname.startsWith("/opret-bruger")) return null;

  const target = expertId ? `/beskriv-problem?ekspert=${expertId}` : "/beskriv-problem";
  const label = expertId && expertName ? `Få hjælp af ${expertName}` : "Få hjælp";

  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-brand-line bg-white/95 px-4 pt-3 backdrop-blur md:hidden" style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)" }} data-testid="mobile-get-help-cta">
    <Link to={target} className="btn-primary flex w-full items-center justify-center gap-2 !py-3 text-[15px]">
      {label} <ArrowRight size={16}/>
    </Link>
  </div>;
}

